export default function CtaFinal() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/2cd48ee2-9a16-446b-8753-475f299f228f_RESIDENCIAL-PINHEIRO-1.png?v=a7693d8e556936250c04a1e837fbc49a"
          alt="Projeto Residencial Pinheiro"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#301531]/75" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-gothic text-white leading-tight mb-6" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)' }}>
          Transforme seu apartamento com planejamento profissional
        </h2>
        <p className="font-montserrat text-[#D6C4D6] text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Entre em contato agora e descubra como a INTRÊ Arquitetura pode transformar seu espaço com estratégia, estética e funcionalidade.
        </p>
        <a
          href="https://wa.me/5511930672567"
          target="_blank"
          rel="nofollow noreferrer"
          className="inline-flex items-center gap-3 px-10 py-4 bg-white text-[#301531] font-montserrat font-bold text-base rounded-full hover:bg-[#D6C4D6] hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-xl text-[#301531]" />
          Falar no WhatsApp
        </a>
      </div>
    </section>
  );
}
